<template>
  <b-card no-body>
    <div class="m-2">

      <!-- Table Top -->
      <b-row>

        <!-- Per Page -->
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <label>{{ $t('Entries') }}</label>
          <v-select
            v-model="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="perPageOptions"
            :clearable="false"
            class="per-page-selector d-inline-block ml-50 mr-1"
          />
          <b-button
            v-b-toggle.sidebar-create-org-monitoring
            variant="primary"
            @click="freshOrgMonitoring"
          >
            {{ $t('Create') }}
          </b-button>
        </b-col>

        <!-- Search -->
        <b-col
          cols="12"
          md="6"
        >
          <div class="d-flex align-items-center justify-content-end">
            <b-form-input
              v-model="searchQuery"
              class="d-inline-block mr-1"
              :placeholder="$t('Search...')"
            />
          </div>
        </b-col>
      </b-row>
    </div>
    <b-table
      ref="orgMonitoringTable"
      :items="list"
      responsive
      :fields="tableColumns"
      primary-key="id"
      :sort-by.sync="sortBy"
      show-empty
      :empty-text="$t('No matching records found')"
      :sort-desc.sync="isSortDirDesc"
      :busy="isBusy"
      class="position-relative"
    >
      <template #head()="data">
        {{ $t(data.label) }}
      </template>

      <!-- Column: Id -->
      <template #cell(index)="data">
        {{ data.index + 1 }}
      </template>
      <template #cell(quarter)="{ value}">
        {{ value.period.admission_year }} / {{ value.quarter }}
      </template>
      <template #cell(file)="data">
        <a
          v-if="data.value"
          :href="data.value"
        >{{ $t('File') }}</a>
      </template>

      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner
            variant="primary"
            label="Text Centered"
          />
        </div>
      </template>
      <template #cell(actions)="data">

        <div class="text-nowrap">
          <feather-icon
            icon="EyeIcon"
            class="cursor-pointer mr-1"
            size="16"
            @click="$router.push({ name: 'check-monitoring-list', params: { id: data.item.id }})"
          />
          <feather-icon
            v-b-toggle.sidebar-create-org-monitoring
            icon="EditIcon"
            class="cursor-pointer"
            size="16"
            @click="update(data.item)"
          />
        </div>
      </template>
    </b-table>

    <div class="mx-2 mb-2">
      <b-row>
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          <span class="text-muted">{{ $t("table summary", { from: dataMeta.from, to: dataMeta.to, of: dataMeta.of }) }} </span>
        </b-col>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >

          <b-pagination
            v-model="currentPage"
            :total-rows="total"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>

        </b-col>
      </b-row>
    </div>
    <create
      ref="orgMonitoringForm"
      @refetchData="refetchData"
    />
  </b-card>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BSpinner,
  BTable, BPagination, VBToggle,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import config from './config'

import Create from './Create.vue'

export default {
  name: 'OrgMonitoring',
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BSpinner,
    BTable,
    BPagination,
    vSelect,
    Create,
  },
  methods: {
    freshOrgMonitoring() {
      this.$store.commit(`${this.MODULE_NAME_ORG_MONITORING}/FRESH`)
    },
    update(data) {
      this.$store.commit(`${this.MODULE_NAME_ORG_MONITORING}/UPDATE`, {
        id: data.id,
        period: data.quarter.period.id,
        quarter: data.quarter.id,
        file: data.file,
      })
      this.$refs.orgMonitoringForm.loadQuarters(data.quarter.period.id)
    },
  },
  setup() {
    const MODULE_NAME_ORG_MONITORING = 'orgMonitoring'
    return {
      MODULE_NAME_ORG_MONITORING,
      ...config(),
    }
  },
}
</script>

<style scoped>

</style>
